import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { SearchPageComponent } from './components/page/search-page.component';
import { SearchRoutingModule } from './search-routing.module';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SearchSidenavComponent } from './components/sidenav/search-sidenav.component';
import { AppliedFiltersComponent } from './components/applied-filters/applied-filters.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Angulartics2Module } from 'angulartics2';
import { ItemTileModule } from '../shared/item-tile/item-tile.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [
	  SearchPageComponent,
	  SearchInputComponent,
	  SearchSidenavComponent,
	  AppliedFiltersComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SearchRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    Angulartics2Module,
    ItemTileModule,
    MatDividerModule,
    MatListModule,
    MatChipsModule,
    MatBadgeModule,
    NgOptimizedImage
  ]
})
export class SearchModule { }
